import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, TemplateRef, ViewContainerRef, WritableSignal, computed, inject, model, signal } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { UtentiService } from '../utenti.service';
import { IRuolo, IUtente } from '../models/utenti.model';
import { BooleanFieldComponent } from 'src/app/shared/components/fields/boolean-field/boolean-field.component';
import { DatetimeFieldComponent } from 'src/app/shared/components/fields/datetime-field/datetime-field.component';
import { CardComponent } from 'src/app/shared/components/cards/card/card.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { UserRoleService } from '../user-role.service';
import { MDividerComponent } from 'src/app/shared/components/divider/divider.component';
import { MIconComponent } from 'src/app/shared/components/icon/icon.component';
import { IInformation } from '../models/information.model';
import { SidenavComponent } from 'src/app/layout/sidenav/sidenav.component';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import { InputGroupLuogoAreaComponent } from "../components/input-group-luogo-area/input-group-luogo-area.component";
import { AmministrazioneService } from '../aministrazione.service';
import { AuthState } from 'src/app/core/models/auth.model';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import { Information, UserDeleghe } from '../models/user.model';
import { IstatComuniService } from '../../istat-comuni/istat-comuni.service';
import { IstatRegioniService } from '../../istat-regioni/istat-regioni.service';
import { AuthService } from 'src/app/core/services/auth.service';
import {MatDividerModule} from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import { DialogService } from 'src/app/core/services/dialog.service';
import { MyDialogComponent } from '../components/my-dialog/my-dialog.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';
import { RoleState } from 'src/app/core/models/role.model';
@Component({
  selector: 'amministrazione-user-page-dettaglio',
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    MatListModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    PageDetailComponent,
    MatChipsModule,
    MatIconModule,
    MyButtonComponent,
    CardComponent,
    EditableCardComponent,
    MDividerComponent,
    TextFieldComponent,
    MyDialogComponent,
    MatAutocompleteModule,
    DatetimeFieldComponent,
    BooleanFieldComponent,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MIconComponent,
    SidenavComponent,
    InputGroupLuogoAreaComponent
],
  templateUrl: './amministrazione-user-dettaglio-page.component.html',
  styleUrl: './amministrazione-user-dettaglio-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UtentiPageDettaglioComponent implements OnInit {

  @Input() id = '0';
  myControl = new FormControl('');
  form: FormGroup;
  formDialog:FormGroup;
  model: WritableSignal<IUtente | undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();
  selectedRoles: string[] = [];
  ruoli:IRuolo[]=[]
  delegheRegioni=new Array()
  delegheComuni=new Array()
  checkCaricamentoLuoghi:boolean=false
  selectedUserEnabledLocation:any = {};
  updateUserArray: { [key: string]: any } = {};
  viewMatSpinner=false
  readonly generalRegioni = this.generalRegioniService.query.list
  readonly generalComuni = this.generalComuniService.query.list
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(
    public readonly service: UtentiService,
    protected readonly fb: FormBuilder,
    protected readonly sidenav: SidenavService,
    protected readonly vcf: ViewContainerRef,
    public readonly userRoles: UserRoleService,
    public readonly adminService: AmministrazioneService,
    @Inject(IstatRegioniService) public generalRegioniService: IstatRegioniService,
    @Inject(IstatComuniService) public generalComuniService: IstatComuniService,
    private authService:AuthService,
    private cdr : ChangeDetectorRef,
    private dialogService: DialogService,
    @Inject('auth-store') private readonly authStore = inject(SignalStore<AuthState>),
    @Inject('role-store') private readonly roleStore = inject(SignalStore<RoleState>)
  ) {
    this.formDialog = this.fb.group({
      roleId:[[], Validators.required],
     // id:[this.model()?.id, Validators.required],
      validFrom:[null, Validators.required],
      validTo:[null]
    });
    this.form = this.fb.group({
      username: [this.model()?.username, Validators.required], 
      email: [this.model()?.email, Validators.required],
      roleId:[[]],
      id:[this.model()?.id, Validators.required],
      information:[[]],
      regioni:[[]],
      comuni:[[]],
      updateUser:this.fb.group<UserDeleghe>(<UserDeleghe>{}),
      validFrom:[[]],
      validTo:[[]]
    });
  }

  ngOnInit(): void {}

  changeModelSelect(){

    this.selectedRoles = this.model()?.authorization.roles!

    if (this.model()?.__userRoles__) {
  
      this.model()?.__userRoles__?.forEach(el => {
         // this.form.controls['updateUser'].setValue()
          const userDelegheForm = this.createUserDelegheForm(el);
          this.updateUserArray={...this.updateUserArray, [el.__role__!.name!]:userDelegheForm}

        //  updateUserArray.push(userDelegheForm);
          el.information.forEach(informazione => {
              const key = informazione.key.trim();
              const value = JSON.parse(informazione.value.trim());

              // Se la chiave non esiste ancora, creiamo un array per quella chiave
              if (!this.selectedUserEnabledLocation[el.__role__!.name!]) {
                  this.selectedUserEnabledLocation[el.__role__!.name!]=[]
              }
              this.selectedUserEnabledLocation[el.__role__!.name!][key]=value;

      
          });
      });
    
    }


    var roll=this.roleStore.selectKey('role')().map((el:any)=>el.name)
    
    if(roll.length>0){
      this.service.getRoles(roll.join(",")).subscribe((val:any)=>
        {

          this.ruoli=val?.data
      
        })
    }

  
      //this.changeModelSelect()
     
      this.adminService.getDeleghe(parseInt(this.id), this.authStore.selectKey("user")().id)
      .subscribe((value: UserDeleghe[]) => {
        if (value.length > 0) {
          let istatRegioneArray: any[] = []; 
          let istatComuniArray: any[] = [];  
    
          value.forEach((el: UserDeleghe) => {
            if (el.information.length > 0) {
              el.information.forEach((element: Information) => {
                
                if (Object.values(element).includes("istatRegioneDeleghe")) {
                  if (typeof element.value === "string") {
                    let arr = JSON.parse(element.value); 
                    istatRegioneArray.push(...arr); 
                  }
                }
    
  
                if (Object.values(element).includes("istatComuneDeleghe")) {
                  if (typeof element.value === "string") {
                    let arr = JSON.parse(element.value); 
                    istatComuniArray.push(...arr); 
                  }
                }
              });
            }
          });
    
  
          this.delegheRegioni = [...new Set(istatRegioneArray)];
          this.delegheComuni = [...new Set(istatComuniArray)];
    
        }
    
        this.getRegioniComuni()
      });
      
  

   
  }

  getChangeModel(){
    for (const field in this.form.controls) { 
      const control = this.form.get(field);
    }
  }
  getRegioniComuni(){
    this.generalRegioniService.query.getAll()
    this.generalComuniService.query.getAll()
    this.checkCaricamentoLuoghi=true

 }
 showDialog(): void {
  this.viewMatSpinner = true;

  setTimeout(() => {
    const dialogRef = this.dialogService.open(MyDialogComponent, {
      data: {
        title: "Informazioni",
        message: "inserisci un nuovo ruolo e le relative informazioni",
        ruoli: this.ruoli,
        ruoliSelezionati: this.selectedRoles,
        form: this.formDialog,
        model:this.model(),
        reload:this.reload
    //    generalRegioni: this.generalRegioni,
    //    generalComuni: this.generalComuni
      }
    }, '40vw');
    
    dialogRef.afterOpened().subscribe(() => {
      this.viewMatSpinner = false;
      this.cdr.detectChanges();
    });
    dialogRef.afterClosed().subscribe(() => {
      this.viewMatSpinner = false;
      this.cdr.detectChanges();
    });
  }, 10);  
}
 createUserDelegheForm(deleghe: any): FormGroup {
  console.log(deleghe)
  return this.fb.group({
    id: [deleghe.id],
    userId: [deleghe.userId],
    roleId: [deleghe.roleId],
    information: this.fb.array(deleghe.information.map((info:any) => this.fb.group({
      key: [info.key],
      type: [info.type],
      value: [info.value],
      isArray: [info.isArray]
    }))),
   /* updated: this.fb.group({
      createdBy: [deleghe.updated.createdBy],
      createdAt: [deleghe.updated.createdAt],
    }),
    created: this.fb.group({
      createdBy: [deleghe.created.createdBy],
      createdAt: [deleghe.created.createdAt],
    }),
    deleted: [deleghe.deleted],*/
    updateBy: [this.authService.user().id],
    valid: [deleghe.valid],
    _role_: [deleghe.__role__]
  });
}
onSave(data:FormGroup){
  console.log(data.value, this.authService.user())
  if(data){
    this.adminService.setDelegheRoles(data.value).subscribe(val=>{
      console.log(val)
      this.dialogService.success('Dati salvati con successo.', true);
    })
  }

}
onDelete(){

}
test(){
  console.log(this.form)
}
}

